import { render, staticRenderFns } from "./PeopleSort.vue?vue&type=template&id=a5fb2498"
import script from "./PeopleSort.vue?vue&type=script&lang=js"
export * from "./PeopleSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports